class CollectionTabsComponent extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('.collection-tab__button');
        this.panels = this.querySelectorAll('.collection-tab__panel');
        this.init();
    }

    init() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (e) => this.handleTabClick(e));
        });
    }

    handleTabClick(e) {
        const clickedButton = e.currentTarget;
        const targetTabId = clickedButton.getAttribute('data-tab-id');

        // Remove active class from all buttons and panels
        this.buttons.forEach((btn) => btn.classList.remove('active'));
        this.panels.forEach((panel) => panel.classList.remove('active'));

        // Add active class to clicked button and corresponding panel
        clickedButton.classList.add('active');
        const targetPanel = this.querySelector(`[data-tab-panel="${targetTabId}"]`);
        if (targetPanel) {
            targetPanel.classList.add('active');
        }

        // Scroll to top of section smoothly
        // this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}

if (!customElements.get('collection-tabs-component')) {
    customElements.define('collection-tabs-component', CollectionTabsComponent);
}
